<template>
    <div class="faq">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="collapse_box">
                <div role="tablist">
                    <b-card no-body v-for="(card, index) in cards" v-bind:key="index">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block v-b-toggle="`accordion${index}`">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <template v-if="card.CompnayId == 'A0'">
                                            <img :src="require(`@/assets/images/icon/news_trplus_hover.svg`)">
                                        </template>
                                        <template v-else>
                                            <img :src="require(`@/assets/images/icon/news_hola_hover.svg`)">
                                        </template>
                                    </div>
                                    <!-- <div class="col-auto title">{{ card.ObjectId }}</div> -->
                                    <div class="col col-md-8 white_space text-left">{{ card.QuestionDesc }}</div>
                                    <div class="col-auto col-md text-right">
                                        <div class="arrow"></div>
                                    </div>
                                </div>
                            </b-btn>
                        </b-card-header>
                        <b-collapse :id="`accordion${index}`" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <h4 class="title">{{ card.Btitle }}</h4>
                                <p class="card-text">
                                    {{ card.AnswerDesc }}
                                </p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import questionAnswerApi from '@/api/questionAnswer'

    export default {
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '常見問題',
                        active: true
                    }
                ],
                cards: [],
                company: 1
            }
        },
        components: {
            Breadcrumbs,
        },
        created() {
            this.createMetaTag();
        },
        destroyed() {
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
            metaTags.forEach((metaTag) => {
              metaTag.parentNode.removeChild(metaTag);
            });
        },
        methods: {
            queryCompany(id) {
                questionAnswerApi.queryCompany({
                    CompanyId: id
                }, (data) => {
                    this.cards = data ? data : []
                });
            },
            get() {
                questionAnswerApi.get((data) => {
                    this.cards = data ? data : []
                });
            },
            createMetaTag() {
              let currentDomain = window.location.hostname;
              let logoUrl = require(`@/assets/images/icon/logo_2020.png`)
              // Create new meta tags
              const metaImage = document.createElement('meta');
              metaImage.setAttribute('property', 'og:image');
              metaImage.setAttribute('content', 'https://' + currentDomain + logoUrl);
              document.head.appendChild(metaImage);

              const metaTitle = document.createElement('meta');
              metaTitle.setAttribute('property', 'og:title');
              metaTitle.setAttribute('content', '常見問題 - 特力屋玩體驗享生活手作DIY課程報名');
              document.head.appendChild(metaTitle);

              const metaDescription = document.createElement('meta');
              metaDescription.setAttribute('property', 'og:description');
              metaDescription.setAttribute('content', '預約報名時最常遇到的問題，都可以在這裡獲得解答！簡單輸入文字即可搜尋，快速查找答案不求人。');
              document.head.appendChild(metaDescription);
            }
        },
        watch: {
            company: {
                immediate: true,
                handler(val) {
                    if (val == 0) {
                        this.get()
                    } else if (val == 1) {
                        this.queryCompany('A0')
                    } else if (val == 2) {
                        this.queryCompany('B0')
                    }
                }
            }
        },

    }
</script>
